<template>
  <div class="ReciprocatMachineryOverviewOpPage" ref="ui">
<!--    <el-container>-->
    <div class="Reciprocat-opPage-header">
      <span class="Reciprocat-opPage-header-text">{{translateText("textMap.","操作页")}}</span>
    </div>
    <div class="Reciprocat-opPage-body">
      <overview-type-op-page class="overviewType" :inputChecked="checked"  @overviewChange="overviewChange"></overview-type-op-page>
      <div class="checked">
        <el-checkbox v-model="checked">{{translateText("textMap.","图谱显示")}}</el-checkbox>
      </div>
      <el-form v-show="checked" ref="ruleForm" :label-width="labelWidth" size="mini">
        <el-form-item :label="translateText('textMap.','设备名称:')" style="min-height:24px;">{{getequName}}</el-form-item>
        <ReciprocatOverviewTree @getTreeData="getmytree" @tmpDataNull='tmpDataNull'></ReciprocatOverviewTree>
        <div class="reciprocat-overview-time-select">
          <RtHisTimeSelect ref='timeset' @radiostatus='changestatus' ></RtHisTimeSelect>
        </div>
        <el-form-item style="margin-bottom: 0px">
          <el-button v-if="nowstatus == 2" @click="FreshHistoryGraph" :loading="loadingStatus" style="font-size: 14px;margin-top: 24px">{{translateText('textMap.','刷新')}}</el-button>
          <el-button v-if='nowstatus == 1 &&freshstatus == 0' @click='startinterval' style="font-size: 14px;margin-top: 24px">{{translateText('textMap.','刷新')}}</el-button>
          <el-button v-if="nowstatus == 1 &&freshstatus == 1" @click='stopinterval' style="font-size: 14px;margin-top: 24px">{{translateText('textMap.','停止')}}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>

  import RtHisTimeSelect from "../ComUtils/RtHisTimeSelect";
  import ReciprocatOverviewTree from "./ReciprocatOverviewTree";
  import keepAliveMixin from "../../mixins/keepAliveMixin";
  import OverviewTypeOpPage from "../ComUtils/OverviewTypeOpPage.vue";
  import event from "@/assets/event";
  //import UnitOverviewMapTree from "../ComUtils/UnitOverviewMapTree";


  export default {
    name: "ReciprocatMachineryOverviewOpPage",
    mixins: [keepAliveMixin],
    components: {
      OverviewTypeOpPage,
      ReciprocatOverviewTree,

     // UnitOverviewMapTree,
      RtHisTimeSelect,

    },
    data() {
      return {
        checked: false,
        nowChecked:0,
        //单通道相关数据
        mypointid: null,
        myinterval: null,
        freshstatus: 1,
        nowstatus: 1,
        msg: '',
        EquName: '',
        isnontree: false,
        mytrees: null,
        mytime: null,
        lasttree: null,
        flag: false,
        ifnowdata:true,   //实时
        loadingStatus: false, //历史模式下接口是否已经返回结果
        ProcessOverviewShow: this.$store.state.ProcessOverviewShow, //是否显示工艺量概貌图
        FreshHistoryFlag:1, //是否第一次进入，第一次进入刷新一次
        labelWidth: this.$i18n.locale == 'ru' ? '110px' : '80px',
      };
    },
    mounted() {
      // this.$parent.dataloading();
      this.$refs.ui.style.setProperty('--conbgcolor', this.$store.state.conbgcolor);
      this.$refs.ui.style.setProperty('--textcolor', this.$store.state.textcolor);
      this.$refs.ui.style.setProperty('--leftconbgcolor', this.$store.state.leftconbgcolor);
      this.$refs.ui.style.setProperty('--activetextcolor', this.$store.state.activetextcolor);
      this.$refs.ui.style.setProperty('--treeinputbgcolor', this.$store.state.treeinputbgcolor);
      this.$refs.ui.style.setProperty('--labelcolor', this.$store.state.labelcolor);
      this.$refs.ui.style.setProperty('--checkedcolor', this.$store.state.checkedcolor);
      this.$refs.ui.style.setProperty('--buttoncolor', this.$store.state.buttoncolor);
      this.$refs.ui.style.setProperty('--buttontextcolor', this.$store.state.buttontextcolor);
      this.$refs.ui.style.setProperty('--selectbordercolor', this.$store.state.selectbordercolor);
    },

    destroyed() {
      if(this.myinterval) {
        clearInterval(this.myinterval)
      }
    },
    computed: {
      getequName() {
        return this.$store.state.equName;
      },
      topiccolor() {
        return this.$store.state.topiccolor;
      }
    },
    watch: {
      //是否显示趋势图
      checked(val){
        if(!this.activatedFlag) return ;
        if(val){
          this.nowChecked=1;
          this.$store.commit('setflaggraph', true);
          if(!this.$store.state.flaggraph && this.$store.state.flagporight && this.$store.state.flagopleft) {
            this.$store.commit('setmarginleftvalue', '0%');
          }
          this.$emit('showgraph');
        }
        else {
          this.nowChecked=0;
          this.$store.commit('setflaggraph', false);
          this.$store.commit('setmarginleftvalue', '10%');
          this.$emit('notshowgraph');
        }
        this.showGrap();
      },
      //设备变化时重置刷新变量
      getequName(){
        if(!this.activatedFlag) return ;
        if (this.$route.path == '/ReciprocatMachineryGraph/OverviewGraph1') {
          this.FreshHistoryFlag=1;
        }
      },
      topiccolor(val) {
        this.$refs.ui.style.setProperty('--conbgcolor', this.$store.state.conbgcolor);
        this.$refs.ui.style.setProperty('--textcolor', this.$store.state.textcolor);
        this.$refs.ui.style.setProperty('--leftconbgcolor', this.$store.state.leftconbgcolor);
        this.$refs.ui.style.setProperty('--activetextcolor', this.$store.state.activetextcolor);
        this.$refs.ui.style.setProperty('--treeinputbgcolor', this.$store.state.treeinputbgcolor);
        this.$refs.ui.style.setProperty('--labelcolor', this.$store.state.labelcolor);
        this.$refs.ui.style.setProperty('--checkedcolor', this.$store.state.checkedcolor);
        this.$refs.ui.style.setProperty('--buttoncolor', this.$store.state.buttoncolor);
        this.$refs.ui.style.setProperty('--buttontextcolor', this.$store.state.buttontextcolor);
        this.$refs.ui.style.setProperty('--selectbordercolor', this.$store.state.selectbordercolor);
      },
      '$i18n.locale'(val){
        if(val == 'zh'){
          this.labelWidth = '80px'
        }else if(val == 'en'){
          this.labelWidth = '80px'
        }else if(val == 'ru'){
          this.labelWidth = '110px'
        }
      }
    },
    methods: {
      overviewChange(val) {
        this.$emit("overviewChange", val)
        // this.checked = false
      },
      tmpDataNull() {
        this.$parent.$emit('tmpDataNull');
      },
      showGrap(){
        if(this.nowChecked ==1){
          if (this.nowstatus == 1) {
            if(this.myinterval) {
              clearInterval(this.myinterval);
            }
            // console.log("请求shishishsihishis数据")
            this.startinterval();
          } else {
            if (this.myinterval) {
              clearInterval(this.myinterval);
            }
            if(this.FreshHistoryFlag == 1 && this.checked && this.$store.state.historyImmediateFlag) {
              this.FreshHistoryGraph();
              this.FreshHistoryFlag = 0
            }
            if(!this.$store.state.historyImmediateFlag) {
              this.FreshHistoryGraph();
            }
          }
        }else if(this.nowChecked ==0){
          if (this.myinterval) {
            clearInterval(this.myinterval);
          }
        }
      },
      getmytree(mytree, flag) {
        this.mytrees = mytree;    //得到测点树的数据的时候先不请求 ，所以去掉
        this.flag = flag; //标记是否为没有测点
        this.$nextTick(() => {
          //初始时传数据
          this.showGrap();
        });
      },

      changestatus(data) {
        this.nowstatus = data;
        if (this.nowstatus == 1) {
          this.startinterval();
          this.ifnowdata = true;
        } else {
          if (this.myinterval) {
            clearInterval(this.myinterval);
          }
          this.FreshHistoryGraph();
          this.ifnowdata = false;
        }
        this.$emit('static',this.ifnowdata);
      },
      startinterval() {  //实时情况下每三秒接收一次数据
        this.$emit('cleanChart')//点击刷新，清空图谱
        this.freshstatus = 1;
        this.getrealdata();
        this.lasttree = this.mytrees;
        let that = this;
        this.myinterval = setInterval(function () {
          //如果两次间隔的测点树一致之间添加数据n
          if (that.isequaltree(that.mytrees, that.lasttree)) {
            if (that.mytrees.featureSelect != that.lasttree.featureSelect) {
              that.getrealdata();
              that.lasttree = that.mytrees;
            } else {
              if (that.isnontree != true) {  //空树不需要添加数据
                if(that.lasttree.checkedNodes[0].id == '壳体振动' || that.lasttree.checkedNodes[0].id == '曲轴箱振动' || that.lasttree.checkedNodes[0].id == '其它振动'){
                  that.$emit('AddrealGrap', that.$store.state.equid, that.mypointid);
                }else if(that.lasttree.checkedNodes[0].id == '压力' || that.lasttree.checkedNodes[0].id == '温度' || that.lasttree.checkedNodes[0].id == '流量'|| that.lasttree.checkedNodes[0].id == '撞击'|| that.lasttree.checkedNodes[0].id == '其它'){
                  that.$emit('AddoutherrealGrap', that.$store.state.equid, that.mypointid);
                }else if(that.lasttree.checkedNodes[0].id=='活塞杆沉降/偏摆' || that.lasttree.checkedNodes[0].id=='动态压力'){
                  that.$emit('AddPistonrealGrap', that.$store.state.equid, that.mypointid);
                }
                else{
                  that.$emit('cleanChart');
                  that.$parent.$emit('datafail')
                  // console.log('没有数值');
                }
              }
            }
          } else {
            that.lasttree = that.mytrees;
          }
        }, this.$store.state.realTimeTrendUpdateInterval)
      },
      getrealdata() {
        //初始化树，并添加第一次访问的图谱数据
        let that = this;
        if (this.mytrees.checkedNodes.length == 1 ||this.mytrees.checkedNodes.length==0) {
          //判断空树
          this.isnontree = true;
          // this.$emit('cleanChart');
          // that.$parent.$emit('datafail')
          if (this.flag) {
            this.$parent.$emit('tmpDataNull')
          } else {
            this.$emit('cleanChart');
            this.$parent.$emit('pointNull')
          }
        } else {
          this.isnontree = false;
          var pointids = '';
          for (var i = 1; i < this.mytrees.checkedNodes.length; ++i) {
            pointids += this.mytrees.checkedNodes[i].id;
            if (i != this.mytrees.checkedNodes.length - 1) {
              pointids += ','
            }
          }
          this.mypointid = pointids;
          if(this.mytrees.checkedNodes[0].id=='壳体振动' || this.mytrees.checkedNodes[0].id=='曲轴箱振动' || this.mytrees.checkedNodes[0].id=='其它振动'){
            that.$emit('DrawrealGrap', this.$store.state.equid, pointids, this.mytrees.checkedNodes, this.mytrees.featureSelect, this.mytrees.Type);
          }
          else if(this.mytrees.checkedNodes[0].id == '压力' || this.mytrees.checkedNodes[0].id == '温度' || this.mytrees.checkedNodes[0].id == '流量' || this.mytrees.checkedNodes[0].id == '撞击' || this.mytrees.checkedNodes[0].id == '其它' ){
            that.$emit('DrawoutherrealGrap', this.$store.state.equid, pointids, this.mytrees.checkedNodes);
          } else if(this.mytrees.checkedNodes[0].id=='活塞杆沉降/偏摆' || this.mytrees.checkedNodes[0].id=='动态压力'){
            that.$emit('DrawPistonrealGrap', this.$store.state.equid, pointids, this.mytrees.checkedNodes, this.mytrees.featureSelect, this.mytrees.Type);
          }else{
            this.$emit('cleanChart');  //压力和撞击 画图
            this.$parent.$emit('datafail')
            // console.log('没有数值');
          }
        }
      },

      FreshHistoryGraph() {
        event.$emit('updatePrimaryLine'); // 清空主辅游标
        this.$emit('reDataZoomInterval')
        this.$emit('cleanChart')//点击刷新，清空图谱
        this.$store.state.gongyiOverviewIframeHistoryTime = null;
        if (!this.mytrees) {
          return ;
        }
        if (this.mytrees.checkedNodes.length == 1 ||this.mytrees.checkedNodes.length==0) {

          if (this.flag) {
            this.$parent.$emit('tmpDataNull');
          } else {
            this.$emit('cleanChart');
          // this.$parent.$emit('datafail')
            this.$parent.$emit('pointNull')
          }
        } else {
          this.$parent.dataloading();
          this.mytime = this.$refs.timeset.timedata();
          var stime = this.mytime.form.starttime;
          var etime = this.mytime.form.endtime;
          var pointids = '';
          for (var i = 1; i < this.mytrees.checkedNodes.length; ++i) {
            pointids += this.mytrees.checkedNodes[i].id;
            if (i != this.mytrees.checkedNodes.length - 1) {
              pointids += ','
            }
          }
          this.mypointid = pointids;

          if(this.mytrees.checkedNodes[0].id=='壳体振动' || this.mytrees.checkedNodes[0].id=='曲轴箱振动' || this.mytrees.checkedNodes[0].id=='其它振动'){
            this.$emit('DramHistoryGrap', this.$store.state.equid, this.mypointid, stime, etime, this.mytrees.checkedNodes, this.mytrees.featureSelect,this.mytrees.Type);
            this.$emit('getCancelrefinetime',stime, etime)
          }
          else if(this.mytrees.checkedNodes[0].id == '温度' ||this.mytrees.checkedNodes[0].id == '撞击' || this.mytrees.checkedNodes[0].id == '压力' || this.mytrees.checkedNodes[0].id == '流量' || this.mytrees.checkedNodes[0].id == '其它'){
            this.$emit('DramOtherHistoryGrap', this.$store.state.equid, this.mypointid, stime, etime, this.mytrees.checkedNodes, this.mytrees.featureSelect);
              this.$emit('getCancelrefinetime',stime, etime)
          } else if(this.mytrees.checkedNodes[0].id == '活塞杆沉降/偏摆' || this.mytrees.checkedNodes[0].id == '动态压力' ){
            this.$emit('DramPistonHistoryGrap', this.$store.state.equid, this.mypointid, stime, etime, this.mytrees.checkedNodes, this.mytrees.featureSelect,this.mytrees.Type);
              this.$emit('getCancelrefinetime',stime, etime)
          }else{
            this.$emit('cleanChart');
            this.$parent.$emit('datafail')
            // console.log('没有数值');

          }

        }
      },

      isequaltree(tree1, tree2) {
        // console.log(tree1,tree2);
        // console.log('0000000000000000000000000000000000')
        var len1 = tree1.checkedNodes.length;
        var len2 = tree2.checkedNodes.length;
        if (len1 != len2) {
          return false
        } else  {
          for (var i = 0; i < len1; ++i) {
            if (tree1.checkedNodes[i].id != tree2.checkedNodes[i].id ||tree1.featureSelect !=tree2.featureSelect ) {
              return false;
            }
          }
          return true;
        }

      },
      stopinterval() {
        this.freshstatus = 0;
        if (this.myinterval) {
          clearInterval(this.myinterval);
        }
      },
    }

  }
</script>
<style lang="scss">
  .ReciprocatMachineryOverviewOpPage {
    --conbgcolor: #0D0F1F;
    --leftconbgcolor: #222331;
    --textcolor: #ffffff;
    --activetextcolor: #1677FF;
    --treeinputbgcolor: #ffffff;
    --labelcolor: #696B6F;
    --checkedcolor: #1677FF;
    --buttoncolor: #1677FF;
    --buttontextcolor: #ffffff;
    height: 100%;
    .Reciprocat-opPage-header{
      padding: 6px 16px;
      display: flex;
      align-items: center;
      gap: 10px;
      background: var(--leftconbgcolor);
      box-shadow: 0 1px 1px 0 var(--conbgcolor);
      color: var(--textcolor);
    }
    .Reciprocat-opPage-header-text{
      color: var(--checkedcolor);
      height: auto;
      font-family: "Microsoft YaHei";
      font-size: 16px;
      font-weight: 700;
    }
    .Reciprocat-opPage-body{
      height: calc(100% - 65px);
      width: calc(100% - 16px);
      overflow: auto;
      display: flex;
      padding: 16px 8px;
      flex-direction: column;
      flex: 1
    }
    .Reciprocat-opPage-overviewType{
      padding: 0px 8px;
    }
    .el-radio__inner{
      border-color: var(--textcolor);
      background-color: var(--leftconbgcolor);
    }
    .el-radio__inner::after {
      width: 7px;
      height: 7px;
      background-color: var(--checkedcolor);
    }
    .el-radio__input.is-checked .el-radio__inner{
      border-color: var(--checkedcolor);
      background-color: var(--leftconbgcolor);
    }
    .el-checkbox__inner{
      background-color: var(--leftconbgcolor);
      border-color: var(--textcolor)
    }
    .el-checkbox__input.is-checked .el-checkbox__inner{
      border-color: var(--checkedcolor);
      background-color: var(--checkedcolor);
    }
    .el-checkbox__label {
      font-size: 14px;
      color: var(--textcolor)!important;
    }

    .reciprocat-overview-time-select{
      margin: 8px 0 0 0;
      background-color: var(--leftconbgcolor);
    }
    .checked{
      margin: 0 8px 16px 8px;
      background-color: var(--leftconbgcolor);
    }
    .overviewType {
      display: flex;
      align-items: center;
      padding: 0 8px;
      gap: 16px;
      background-color: var(--leftconbgcolor);
      .el-radio__label {
        font-size: 14px;
        color: var(--textcolor);
      }
    }

    .el-form {
      .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
        margin: 0 0 16px 8px;
      }
      .el-select {
        width: 100%;
        .el-input__inner {
          background-color: var(--leftconbgcolor);
          color: var(--selectbordercolor);
          border-color: var(--selectbordercolor);
          font-size: 14px;
        }
      }
      .el-date-editor{
        .el-input__inner {
          background-color: var(--leftconbgcolor);
          color: var(--selectbordercolor);
          border-color: var(--selectbordercolor);
          font-size: 14px;
        }
      }

      .el-form-item__label {
        color: var(--textcolor);
        text-align: left;
        padding: 0px 5px 0px 0px;
      }

      .el-form-item__content {
        color: var(--textcolor);
        font-size: 14px;
      }

      .el-button{
        background: var(--buttoncolor);
        border: var(--checkedcolor);
        color: var(--buttontextcolor);
      }
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/ReciprocatMachineryOverviewOpPage/ReciprocatMachineryOverviewOpPage.vue